import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict,
  superviseInstitutionDict,
  platformTitleDict
} from '@/dictionary/system'

/**
 * 查询统计
 */
export default {
  path: 'monitor',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '查询统计',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [
    workbenchServiceDict.PURCHASER.value,
    workbenchServiceDict.AGENCY.value
  ],
  roles: [
    platformFunctionModuleDict.QUERY_STATS.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 查询统计
    {
      path: 'statistic',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '查询统计',
        icon: 'icon-side_statistics_data'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.QUERY_STATS.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 数据大屏
        {
          path: 'data-screen',
          name: 'DataScreen',
          component: '/project-views/query-statistics/data-screen',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '数据大屏'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 项目统计
        {
          path: 'project-statistic',
          name: 'ProjectStatistic',
          component: '/project-views/query-statistics/project-statistic-list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '项目统计'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 采购驾驶舱
        {
          path: 'data-cockpit',
          name: 'DataCockpit',
          component: '/project-views/query-statistics/data-cockpit',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '采购驾驶舱'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 协同及未协同项目分析
        {
          path: 'collaboration-project-analysis',
          name: 'CollaborationProjectAnalysis',
          component:
            '/project-views/query-statistics/collaboration-project-analysis',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '协同项目分析'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 品目价格分析
        {
          path: 'material-analysis',
          name: 'MaterialAnalysis',
          component: '/project-views/query-statistics/material-analysis',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '品目价格分析'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 供应商分析
        {
          path: 'supplier-analysis',
          name: 'SupplierAnalysis',
          component: '/project-views/query-statistics/supplier-analysis',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '供应商分析'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 代理机构分析
        {
          path: 'agency-analysis',
          name: 'AgencyAnalysis',
          component: '/project-views/query-statistics/agency-analysis',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '代理机构分析'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 自动化报告
        {
          path: 'procurement-report',
          name: 'ProcurementReport',
          component: '/project-views/query-statistics/procurement-report',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '自动化报告'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [
            {
              platformId: platformTitleDict.JXIC.value,
              platformName: platformTitleDict.JXIC.label,
              menuName: '采购报告'
            }
          ],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 数据看板
        // {
        //   path: 'data-board',
        //   type: menuTypeDict.DIRECTORY.value,
        //   meta: {
        //     title: '数据看板'
        //   },
        //   applicableCompanyTypes: [
        //     { companyType: companyTypeDict.ENTERPRISE.value },
        //     { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        //   ],
        //   platformAlias: [],
        //   applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
        //   roles: [
        //     platformFunctionModuleDict.QUERY_STATS.right,
        //     platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
        //   ],
        //   superviseInstitutions: [],
        //
        //   children: [
        //     // 数据看板
        //     {
        //       path: 'index',
        //       name: 'DataBoard',
        //       component: '/project-views/query-statistics/data-board',
        //       type: menuTypeDict.MENU.value,
        //       meta: {
        //         title: '数据看板',
        //         hidden: true,
        //         cache: true,
        //         pageComponentName: 'DataBoard'
        //       },
        //       applicableCompanyTypes: [
        //         { companyType: companyTypeDict.ENTERPRISE.value },
        //         { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        //       ],
        //       platformAlias: [],
        //       applicableCompanyIdentities: [
        //         workbenchServiceDict.PURCHASER.value
        //       ],
        //       roles: [
        //         platformFunctionModuleDict.QUERY_STATS.right,
        //         platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
        //       ],
        //       superviseInstitutions: []
        //     },
        //
        //     // 数据看板详情
        //     {
        //       path: 'data-board-detail',
        //       name: 'DataBoardDetail',
        //       component: '/project-views/query-statistics/data-board-detail',
        //       type: menuTypeDict.MENU.value,
        //       meta: {
        //         title: '数据看板详情',
        //         hidden: true
        //       },
        //       applicableCompanyTypes: [
        //         { companyType: companyTypeDict.ENTERPRISE.value },
        //         { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        //       ],
        //       platformAlias: [],
        //       applicableCompanyIdentities: [
        //         workbenchServiceDict.PURCHASER.value
        //       ],
        //       roles: [
        //         platformFunctionModuleDict.QUERY_STATS.right,
        //         platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
        //       ],
        //       superviseInstitutions: []
        //     }
        //   ]
        // },

        // 定点采购报表
        {
          path: 'fixed-point-report',
          name: 'FixedPointReport',
          component: '/project-views/query-statistics/fixed-point-report',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '定点采购报表'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 品目价格库
    {
      path: 'item-price-library',
      name: 'ItemPriceLibraryList',
      component: '/project-views/item-price-library/list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '品目价格库',
        icon: 'icon-side_statistics_itemprice'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.QUERY_STATS.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 供应商交易数据统计
    {
      path: 'supplier-trade-statistic',
      name: 'SupplierTradeStatisticList',
      component: '/project-views/supplier-trade-statistic/list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '供应商交易数据统计',
        icon: 'icon-side_statistics_tradedata'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.QUERY_STATS.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 成交供应商
    {
      path: 'deal-supplier',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '成交供应商',
        icon: 'icon-side_statistics_trade_search'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.QUERY_STATS.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 供应商列表
        {
          path: 'list',
          name: 'DealSupplierList',
          component: '/project-views/deal-supplier/list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '供应商列表',
            cache: true,
            hidden: true,
            pageComponentName: 'DealSupplierList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 供应商详情
        {
          path: 'detail/:supplierId',
          name: 'DealSupplierDetail',
          component: '/project-views/deal-supplier/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '供应商详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 采购项目查询
    {
      path: 'purchaser',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '采购项目查询',
        icon: 'icon-side_statistics_purchase'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.QUERY_STATS.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 招标采购
        {
          path: 'bid',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '招标采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 招标列表
            {
              path: 'list',
              name: 'QueryBid',
              component: '/project-views/project-query/query-bid',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '招标列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryBid'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'BiddingProjectDetail',
              component: '/project-views/bidding/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 招标文件
            {
              path: 'orders/:orderId/file-info/:biddingFileId',
              name: 'ProjectInviteBidFileInfo',
              component:
                '/procure-views/purchase/invite-bid/invite-bid-detail/bid-file-detail',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '招标文件',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 备案采购
        {
          path: 'supplement',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '备案采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [superviseInstitutionDict.JXGZW.value],

          children: [
            // 备案列表
            {
              path: 'list',
              name: 'QuerySupplement',
              component: '/project-views/project-query/query-supplement',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '备案列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QuerySupplement'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: [superviseInstitutionDict.JXGZW.value]
            },

            // 项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'SupplementProjectDetail',
              component: '/project-views/bidding/supplement',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: [superviseInstitutionDict.JXGZW.value]
            }
          ]
        },

        // 询比采购
        {
          path: 'inquiry',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '询比采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 询比列表
            {
              path: 'list',
              name: 'QueryInquiry',
              component: '/project-views/project-query/query-inquiry',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '询比列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryInquiry'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'InquiryProjectDetail',
              component: '/project-views/inquiry-project/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 竞价采购
        {
          path: 'compete',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '竞价采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 竞价列表
            {
              path: 'list',
              name: 'QueryCompete',
              component: '/project-views/project-query/query-compete',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '竞价列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryCompete'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'CompeteProjectDetail',
              component: '/project-views/compete/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 谈判采购
        {
          path: 'negotiation',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '谈判采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 谈判列表
            {
              path: 'list',
              name: 'QueryNegotiation',
              component: '/project-views/project-query/query-negotiation',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '谈判列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryNegotiation'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 机场项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'NegotiationProjectDetail',
              component: '/project-views/negotiation/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '机场项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                {
                  companyType: companyTypeDict.ENTERPRISE.value,
                  menuName: '项目详情'
                },
                {
                  companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
                  menuName: '项目详情'
                }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 医院项目详情
            {
              path: 'v2/orders/:orderId/detail',
              name: 'NegotiationV2ProjectDetail',
              component: '/project-views/negotiation-v2/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '医院项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                {
                  companyType: companyTypeDict.ENTERPRISE.value,
                  menuName: '项目详情'
                },
                {
                  companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
                  menuName: '项目详情'
                }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 直接采购
        {
          path: 'direct',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '直接采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 采购列表
            {
              path: 'list',
              name: 'QueryDirect',
              component: '/project-views/project-query/query-direct',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '采购列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryDirect'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'DirectProjectDetail',
              component: '/project-views/direct/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [
                workbenchServiceDict.PURCHASER.value
              ],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        }
      ]
    },

    // 代理项目查询
    {
      path: 'agency',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '代理项目查询',
        icon: 'icon-side_statistics_agency'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
      roles: [
        platformFunctionModuleDict.QUERY_STATS.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 招标采购
        {
          path: 'bid',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '招标采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 招标列表
            {
              path: 'list',
              name: 'QueryAgencyBid',
              component: '/project-views/project-query/agency-query-bid',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '招标列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryAgencyBid'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'AgencyBiddingProjectDetail',
              component: '/project-views/bidding/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 招标文件详情
            {
              path: 'orders/:orderId/file-info/:biddingFileId',
              name: 'AgencyProjectInviteBidFileInfo',
              component:
                '/procure-views/purchase/invite-bid/invite-bid-detail/bid-file-detail',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '招标文件详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 询比采购
        {
          path: 'inquiry',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '询比采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 询比列表
            {
              path: 'list',
              name: 'QueryAgencyInquiry',
              component: '/project-views/project-query/agency-query-inquiry',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '询比列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryAgencyBid'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'AgencyInquiryProjectDetail',
              component: '/project-views/inquiry-project/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 竞价采购
        {
          path: 'compete',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '竞价采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 竞价列表
            {
              path: 'list',
              name: 'QueryAgencyCompete',
              component: '/project-views/project-query/agency-query-compete',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '竞价列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryAgencyCompete'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'AgencyCompeteProjectDetail',
              component: '/project-views/compete/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 谈判采购
        {
          path: 'negotiation',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '谈判采购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 谈判列表
            {
              path: 'list',
              name: 'QueryAgencyNegotiation',
              component:
                '/project-views/project-query/agency-query-negotiation',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '谈判列表',
                cache: true,
                hidden: true,
                pageComponentName: 'QueryAgencyNegotiation'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 机场项目详情
            {
              path: 'orders/:orderId/detail',
              name: 'AgencyNegotiationProjectDetail',
              component: '/project-views/negotiation/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '机场项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                {
                  companyType: companyTypeDict.ENTERPRISE.value,
                  menuName: '项目详情'
                },
                {
                  companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
                  menuName: '项目详情'
                }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 谈判项目详情
            {
              path: 'v2/orders/:orderId/detail',
              name: 'AgencyNegotiationV2ProjectDetail',
              component: '/project-views/negotiation-v2/index',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '谈判项目详情',
                hidden: true
              },
              applicableCompanyTypes: [
                {
                  companyType: companyTypeDict.ENTERPRISE.value,
                  menuName: '项目详情'
                },
                {
                  companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
                  menuName: '项目详情'
                }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
              roles: [
                platformFunctionModuleDict.QUERY_STATS.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        }
      ]
    },

    // 标书费查询
    {
      path: 'tender-fee',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '标书费查询',
        icon: 'icon-side_statistics_fee'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.QUERY_STATS.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 标书费列表
        {
          path: 'list',
          name: 'TenderFeeList',
          component: '/project-views/tender-fee',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '标书费列表',
            cache: true,
            hidden: true,
            pageComponentName: 'TenderFeeList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 标书费详情
        {
          path: 'detail/:orderId/:orderName/:bookFeeTotalAmount',
          name: 'TenderFeeDetail',
          component: '/project-views/tender-fee/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '标书费详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    }
  ]
}
